// Modules
import { ReactNode } from "react"
import styled from "styled-components"

export interface InputColorHexWrapperProps {
  color: string
  children: ReactNode
}

const InputColorHexWrapper = ({
  color,
  children,
}: InputColorHexWrapperProps) => {
  return (
    <InputWrapper>
      {children}

      <ColorRepresentation style={{ backgroundColor: color }} />
    </InputWrapper>
  )
}

export default InputColorHexWrapper

const InputWrapper = styled.div`
  position: relative;
`

const ColorRepresentation = styled.span`
  border-radius: 4px;
  display: inline-block;
  height: 22px;
  position: absolute;
  right: 0;
  top: 28px;
  width: 22px;
`
